module.exports = __webpack_public_path__ + "static/media/tick.45ae5067.png";